
import { defineComponent, PropType, ref, computed } from 'vue'

export default defineComponent({
  name: 'AcExpansionPanel',
  props: {
    panel: {
      type: Object,
      required: true
    },
    fields: {
      type: Object as PropType<{ title: string, text: string }>,
      default: () => ({ title: 'title', text: 'text' })
    },
    expandIcon: {
      type: Object as PropType<{ expand: 'chevron-down' | 'plus', collapse: 'chevron-up' | 'minus' }>,
      default: () => ({ expand: 'chevron-down', collapse: 'chevron-up' })
    }
  },
  setup (props) {
    const isClosePanel = ref(true)
    const icon = computed(() => isClosePanel.value ? props.expandIcon.expand : props.expandIcon.collapse)

    function togglePanel () {
      isClosePanel.value = !isClosePanel.value
    }

    return {
      isClosePanel,
      icon,
      togglePanel
    }
  }
})
